import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';

export class DayOfWeekHours {
  @autoserialize
  dayOfWeek: string;

  @autoserialize
  closed: boolean;

  @autoserializeAs
  closedForLunch: boolean;

  @autoserializeAs(Date)
  open: Date;

  @autoserializeAs(Date)
  close: Date;

  @autoserializeAs(Date)
  lunchStart: Date;

  @autoserializeAs(Date)
  lunchEnd: Date;

  /**** Serialization ****/

  static OnSerialized(instance: DayOfWeekHours, json: any): void {
    if (!isNullOrUndefined(instance.open)) {
      json.open = DateUtil.serializeLocalDate(instance.open);
    }

    if (!isNullOrUndefined(instance.close)) {
      json.close = DateUtil.serializeLocalDate(instance.close);
    }

    if (!isNullOrUndefined(instance.lunchStart)) {
      json.lunchStart = DateUtil.serializeLocalDate(instance.lunchStart);
    }

    if (!isNullOrUndefined(instance.lunchEnd)) {
      json.lunchEnd = DateUtil.serializeLocalDate(instance.lunchEnd);
    }
  }

  static OnDeserialized(instance: DayOfWeekHours, json: any): void {
    if (!isNullOrUndefined(json['open'])) {
      instance.open = DateUtil.deserializeLocalDate(json['open']);
    }

    if (!isNullOrUndefined(json['close'])) {
      instance.close = DateUtil.deserializeLocalDate(json['close']);
    }

    if (!isNullOrUndefined(json['lunchStart'])) {
      instance.lunchStart = DateUtil.deserializeLocalDate(json['lunchStart']);
    }

    if (!isNullOrUndefined(json['lunchEnd'])) {
      instance.lunchEnd = DateUtil.deserializeLocalDate(json['lunchEnd']);
    }
  }
}
